export function DocText({ text }) {
  const lines = text.split("\n");
  return (
    <div>
      {lines.map((ln, i) => {
        const t = ln.trim();
        if (!t) return <div key={i} className="h-2" />;
        if (/^\d+\.\s+[A-Z][A-Z\s\-&]+$/.test(t))
          return <h2 key={i} className="mt-8 border-b border-[#E2E8F0] pb-2 font-display text-2xl text-[#1E293B]">{t}</h2>;
        if (/^[A-Z][A-Z\s\-&,]{4,}$/.test(t))
          return <h3 key={i} className="mt-6 font-display text-xl text-[#1E293B]">{t}</h3>;
        if (/^(Purpose|How to do it|Example|Reflect|Your challenge|Challenge|Important rule|Important|Final Challenge)/.test(t))
          return <p key={i} className="mt-3 text-sm font-semibold uppercase tracking-wide text-[#2563EB]">{t}</p>;
        if (/^\d+\.\s+[A-Z]/.test(t))
          return <p key={i} className="mt-4 font-display text-lg text-[#1E293B]">{t}</p>;
        return <p key={i} className="mt-1.5 text-sm leading-relaxed text-[#1E293B]/80">{t}</p>;
      })}
    </div>
  );
}
